import { colorStrings } from "@iewccouk/Utilities/variables";
import { TooltipPresentationProps } from "@insite/mobius/Tooltip";
import { safeColor } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import RecursivePartial from "@insite/mobius/utilities/RecursivePartial";
import { css } from "styled-components";

export const tooltip: RecursivePartial<{
    defaultProps?: TooltipPresentationProps;
}> = {
    defaultProps: {
        mergeCss: true,
        iconProps: {
            color: colorStrings.textMain,
            size: 16,
            css: css`
                margin: 0 4px;
            `,
        },
        cssOverrides: {
            tooltipContainer: css`
                box-shadow: 0 5px 20px ${safeColor(getColor(colorStrings.commonGlobalBlack)).rgb().alpha(0.2).string()};
                z-index: 999;
                border-radius: 5px;

                &&&& p {
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 16px;
                }

                &::after {
                    border-color: ${getColor(colorStrings.commonGlobalWhite)} transparent transparent transparent;
                }
            `,
            tooltipBody: css`
                background-color: ${getColor(colorStrings.commonGlobalWhite)};
                color: ${getColor(colorStrings.textMain)};
                border: 1px solid ${getColor(colorStrings.commonGlobalGray01)};
            `,
            tooltipArrow: css`
                border-color: ${getColor(colorStrings.commonGlobalGray01)} transparent transparent transparent;

                &::before {
                    content: "";
                    position: absolute;
                    top: -7px;
                    left: 50%;
                    transform: translateX(-50%);
                    border-width: 5px;
                    border-style: solid;
                    border-color: ${getColor(colorStrings.commonGlobalWhite)} transparent transparent transparent;
                }
            `,
        },
        typographyProps: {
            size: 12,
            lineHeight: "16px",
        },
    },
};
